
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 0 0"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 0c1.979 0 3.705.532 5.18 1.596a19.754 19.754 0 012.674 2.31c.798.815 1.41 1.497 1.838 2.047L21 7l-.09.128c-.096.135-.209.289-.34.463l-.284.375c-.308.401-.929 1.083-1.862 2.044-.933.961-1.848 1.76-2.744 2.394C14.205 13.468 12.479 14 10.5 14c-1.997 0-3.733-.532-5.208-1.596a19.754 19.754 0 01-2.674-2.31C1.82 9.279 1.208 8.597.78 8.047l-.136-.179L0 7l.09-.128c.16-.224.367-.504.624-.838l.164-.205c.34-.413.902-1.026 1.684-1.839.924-.961 1.834-1.76 2.73-2.394C6.767.532 8.502 0 10.5 0zm0 2.324c-1.456 0-2.735.392-3.836 1.176-1.157.821-2.39 1.988-3.696 3.5 1.27 1.475 2.501 2.632 3.696 3.472 1.101.784 2.38 1.176 3.836 1.176s2.735-.392 3.836-1.176c1.195-.84 2.427-1.997 3.696-3.472-1.307-1.512-2.539-2.679-3.696-3.5-1.101-.784-2.38-1.176-3.836-1.176zm0 1.176c.97 0 1.797.34 2.478 1.022C13.659 5.203 14 6.029 14 7s-.345 1.801-1.036 2.492c-.672.672-1.493 1.008-2.464 1.008s-1.797-.34-2.478-1.022C7.341 8.797 7 7.971 7 7s.34-1.797 1.022-2.478C8.703 3.841 9.529 3.5 10.5 3.5zm0 1.148c-.635 0-1.18.229-1.638.686A2.268 2.268 0 008.176 7c0 .635.224 1.18.672 1.638.448.457.999.686 1.652.686s1.204-.229 1.652-.686A2.259 2.259 0 0012.824 7a2.2 2.2 0 00-.7-1.652c-.448-.467-.99-.7-1.624-.7zm0 1.176c.317 0 .593.117.826.35.233.233.35.509.35.826s-.117.588-.35.812c-.233.224-.509.336-.826.336s-.593-.112-.826-.336c-.233-.224-.35-.495-.35-.812s.112-.588.336-.812c.243-.243.523-.364.84-.364z"}})])
          )
        }
      }
    